import { mfgCompactGhostBtnClass } from "@/components/manufacturing/manufacturingSurfaceClasses";
import { COLUMN_BAND_LABEL } from "@/lib/manufacturing/cogsColumnEdit";
import { updateManufacturingPricingLayerColumn } from "@/lib/manufacturing/pricingLayersClient";
import type { MfgPricingLayerColumn } from "@/lib/manufacturing/types";

export async function setPricingColumnOnGrid(columnId: string, onGrid: boolean): Promise<void> {
  const saved = await updateManufacturingPricingLayerColumn({ column_id: columnId, is_active: onGrid });
  if (!saved.ok) throw new Error(saved.error);
}

export function PricingOffGridColumns({
  columns,
  locked,
  onAttach,
}: {
  columns: readonly MfgPricingLayerColumn[];
  locked: boolean;
  onAttach: (column: MfgPricingLayerColumn) => void;
}) {
  const offGrid = columns.filter((column) => !column.is_active);
  if (offGrid.length === 0) return null;
  return (
    <section className="space-y-2">
      <h3 className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-zinc-400">Off the grid</h3>
      <p className="text-xs text-gray-500 dark:text-zinc-400">
        These columns are priced in the product drill. They are not in the COGS totals.
      </p>
      {offGrid.map((column) => (
        <div key={column.id} className="flex flex-wrap items-center justify-between gap-2 text-sm">
          <span>
            {column.label}{" "}
            <span className="text-xs text-gray-500 dark:text-zinc-400">{COLUMN_BAND_LABEL[column.band]}</span>
          </span>
          <button
            type="button"
            className={mfgCompactGhostBtnClass}
            disabled={locked}
            onClick={() => onAttach(column)}
          >
            Put on the grid
          </button>
        </div>
      ))}
    </section>
  );
}
